// import http from ''
import { get } from './axios'
/**
 *  校验准考证号
 */
export const checkExchangeCode = data => get('level/checkExchangeCode', data)
// 根据id获取考级题数据
export const getEnrollItemBankByEnrollGradeId = data => get('level/getEnrollItemBankByEnrollGradeId', data)
// 添加报名信息的分数
export const updateEnrollFractionById = data => get('level/updateEnrollFractionById', data)
// 添加收获信息
export const updateEnrollAddressById = data => get('level/updateEnrollAddressById', data)
// 根据id获取十三级考试数据
export const getWalkingEnrollItemBank = data => get('level/getWalkingEnrollItemBank', data)
// 根据id获取十二级考试数据
export const getWalkingEnrollItemBank12 = data => get('level/getWalkingEnrollItemBank12', data)
// 校验围棋准考证号
export const goExchangeCode = data => get('level/checkGoExchangeCode', data)
// 添加围棋考级收获信息
export const goUpdata = data => get('level/updateGoEnrollAddressById', data)
// 国际象棋获取题数据接口
export const getGjxqEnrollItemBank = data => get('level/getGjxqEnrollItemBank', data)
// 添加国际象棋考级收获信息
export const chessUpdata = data => get('level/updateGjxqEnrollAddressById', data)
// 保存国际象棋分数
export const chessEnrollFractionById = data => get('level/updateGjxqEnrollFractionById', data)
// 校验国际象棋准考证号
export const checkGjxqExchangeCode = data => get('level/checkGjxqExchangeCode', data)



// WEBPACK FOOTER //
// ./src/api/index.js